import styled from 'styled-components'

import { RoleTone, theme } from '../../constants'

export const BannerLayout = styled.section`
  position: relative;
  min-height: 250px;
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(260px, 0.65fr);
  overflow: hidden;
  background: ${theme.semanticColors.background.editorial};
  border-radius: ${theme.radii.xlarge};
  box-shadow: ${theme.shadows.medium};

  @media (max-width: ${theme.breakpoints.desktop}) {
    grid-template-columns: minmax(0, 1fr) 260px;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`

export const BannerContent = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: ${theme.spacing[8]} ${theme.spacing[12]};
  color: ${theme.colors.white};
  text-align: left;

  h2 {
    max-width: 560px;
    margin: ${theme.spacing[3]} 0;
    font-size: ${theme.typography.size.h1};
    font-weight: ${theme.typography.weight.bold};
    line-height: ${theme.typography.lineHeight.heading};
    letter-spacing: -0.035em;
  }

  p {
    max-width: 540px;
    margin: 0 0 ${theme.spacing[6]};
    color: #cfd0da;
    font-size: ${theme.typography.size.bodySmall};
    line-height: ${theme.typography.lineHeight.body};
  }

  @media (max-width: ${theme.breakpoints.desktop}) {
    padding: ${theme.spacing[8]};
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: ${theme.spacing[6]};

    h2 {
      font-size: ${theme.typography.size.h2};
    }
  }
`

export const BannerEyebrow = styled.span<{ $tone: RoleTone }>`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  color: ${({ $tone }) => theme.roleColors[$tone].main};
  font-size: ${theme.typography.size.bodySmall};
  font-weight: ${theme.typography.weight.bold};
  text-align: left;
`

export const BannerVisual = styled.div<{ $tone: RoleTone }>`
  position: relative;
  min-height: 250px;
  overflow: hidden;
  background: ${({ $tone }) => theme.roleColors[$tone].main};

  @media (max-width: ${theme.breakpoints.tablet}) {
    min-height: 150px;
  }
`
